<!DOCTYPE html>
<div id="regist-screen"> </div>
<div id="setting-screen" class="container-fluid content-row">
  <header>
    <img src="../../assets/images/SonicRain.png" alt="">
  </header>
  <div id="content">
    <div *ngIf="!user" class="card text-center" id="card">
      <h6 class="card-header">
        響雨實況主互動系統
      </h6>
      <div *ngIf="app" id="logingroup">
        <button mat-raised-button (click)="logIn()" id="alreadyhave">登入</button>
      </div>
        <!-- <button mat-raised-button (click)="register()" id="regist">註冊</button>
      </div> -->
      <!-- <div *ngIf="registerState != 0"> -->
        <div class="card-block" *ngIf="!app">
          <h4 class="card-title">尚未登入</h4>
        </div>
        <div class="card-block" id="cardbtn" *ngIf="!app">
          <br>
          <!-- <a class="btn btn-block btn-social btn-facebook" (click)="signInWithFB()">
            <span class="fa fa-facebook"></span> Sign in with FaceBook
          </a> -->
          <a class="btn btn-block btn-social btn-google" (click)="signInWithGoogle()">
            <span class="fa fa-google"></span> Sign in with Google
          </a>
        </div>
      </div>
    <!-- </div> -->
    <div *ngIf="user" class="card text-center">
      <h6 class="card-header">
        響雨實況主互動系統
      </h6>

      <div class="card-block"></div>
      <!-- <img *ngIf="user.photoUrl" class="card-img-top img-responsive photo" src="{{ user.photoUrl }}"> -->
      <div class="card-block">
        <!-- <h4 class="card-title">{{ user.name }}</h4>
        <p class="card-text">{{ user.email }}</p> -->
      </div>
      <div class="card-block">
        <button mat-button color="warn" (click)="signOut()" >Sign out</button>
      </div>
      <mat-form-field class="example-full-width" *ngIf="registerState == 2">
        <mat-label>ID</mat-label>
        <input type="text" matInput placeholder="Your ID" value="Sushi"  [(ngModel)]="id" pattern="">
      </mat-form-field>
      <button mat-stroked-button  (click)="submit()" id="sendbtn" *ngIf="registerState == 2">送出</button>
    </div>
    <div id="email">
      <mat-icon id="emailicon">email</mat-icon>
      <span>: support@hibiki-rain.com</span>
    </div>
  </div>
</div>
<div class="copyright">
  <a> Copyright &copy; Sonic Rain Interactive Entertainment Co., Ltd. All rights reserved.</a>
</div>
